import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../services/api";

export default function ProcessoDetalhe() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [novaMov, setNovaMov] = useState("");
  const [novoPrazo, setNovoPrazo] = useState({
    data_prazo: "",
    descricao: ""
  });

  function carregar() {
    api.get(`/admin_processo_detalhe.php?id=${id}`)
      .then(res => setData(res.data));
  }

  useEffect(() => {
    carregar();
  }, [id]);

  if (!data) {
    return <div className="p-6 text-slate-400">Carregando...</div>;
  }

  async function criarMovimentacao() {
    await api.post("/admin_create_movimentacao.php", {
      processo_id: id,
      descricao: novaMov
    });
    setNovaMov("");
    carregar();
  }

  async function criarPrazo() {
    await api.post("/admin_create_prazo.php", {
      processo_id: id,
      data_prazo: novoPrazo.data_prazo,
      descricao: novoPrazo.descricao
    });
    setNovoPrazo({ data_prazo: "", descricao: "" });
    carregar();
  }

  const { processo, movimentacoes, prazos } = data;

  return (
    <div className="p-6 space-y-8">

      {/* CABEÇALHO */}
      <div>
        <h1 className="text-xl font-semibold text-slate-100">
          Processo nº {processo.numero}
        </h1>
        <p className="text-sm text-slate-400">
          {processo.vara} • {processo.comarca}
        </p>
      </div>

      {/* NOVA MOVIMENTAÇÃO */}
      <div className="rounded-xl border border-[#1f2937] bg-[#121826] p-4">
        <h2 className="text-lg font-semibold text-slate-100 mb-2">
          Nova movimentação
        </h2>
        <textarea
          value={novaMov}
          onChange={e => setNovaMov(e.target.value)}
          className="w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3 text-sm text-slate-100"
          placeholder="Descreva a movimentação..."
        />
        <button
          onClick={criarMovimentacao}
          className="mt-3 rounded-lg bg-blue-600 px-4 py-2 text-sm hover:bg-blue-500"
        >
          Salvar movimentação
        </button>
      </div>

      {/* NOVO PRAZO */}
      <div className="rounded-xl border border-[#1f2937] bg-[#121826] p-4">
        <h2 className="text-lg font-semibold text-slate-100 mb-2">
          Novo prazo
        </h2>

        <input
          type="date"
          value={novoPrazo.data_prazo}
          onChange={e => setNovoPrazo({ ...novoPrazo, data_prazo: e.target.value })}
          className="mb-2 w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3 text-sm"
        />

        <input
          type="text"
          value={novoPrazo.descricao}
          onChange={e => setNovoPrazo({ ...novoPrazo, descricao: e.target.value })}
          placeholder="Descrição do prazo"
          className="w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3 text-sm"
        />

        <button
          onClick={criarPrazo}
          className="mt-3 rounded-lg bg-green-600 px-4 py-2 text-sm hover:bg-green-500"
        >
          Salvar prazo
        </button>
      </div>

      {/* LISTAS */}
      <div className="grid md:grid-cols-2 gap-6">

        {/* PRAZOS */}
        <div>
          <h3 className="font-semibold text-slate-100 mb-3">Prazos</h3>
          {prazos.map(p => (
            <div key={p.id} className="mb-2 rounded-xl bg-[#121826] p-3">
              <p className="text-sm text-slate-100">{p.descricao}</p>
              <p className="text-xs text-slate-400">
                {new Date(p.data_prazo).toLocaleDateString()}
              </p>
            </div>
          ))}
        </div>

        {/* MOVIMENTAÇÕES */}
        <div>
          <h3 className="font-semibold text-slate-100 mb-3">Movimentações</h3>
          {movimentacoes.map(m => (
            <div key={m.id} className="mb-2 rounded-xl bg-[#121826] p-3">
              <p className="text-sm text-slate-100">{m.descricao}</p>
              <p className="text-xs text-slate-400">
                {new Date(m.criado_em).toLocaleDateString()}
              </p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
